import { styles } from 'assets/scss/style-templates';

export const tenantOngoingIssueUpdateModalClasses = (isNoteValid: boolean) => ({
  actionsContainer: { display: 'flex', flexDirection: 'row', gap: 1 },
  actionButton: { width: '100px', borderRadius: '5px' },
  contentContainer: { mt: 2 },
  inputsContainer: { width: '400px', gap: 2 },
  issueField: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: !isNoteValid
          ? styles.color.warn
          : styles.color.monotoneLightLight,
      },
      '&:hover fieldset': {
        borderColor: !isNoteValid
          ? styles.color.warn
          : styles.color.monotoneLightLight,
      },
      '&.Mui-focused fieldset': {
        borderColor: !isNoteValid ? styles.color.warn : styles.color.darkShade,
      },
    },
  },
  errorWarningText: {
    pt: 0,
    pb: 0,
    fontSize: '11px',
    color: styles.color.warn,
  },
});
